import { Injectable } from '@angular/core';
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  private conexioBankTransferAccountID: Array<string> = Constants.HERTZ_ACCOUNT_ID;

  wireTransferStatement: string = "Wire Transfer Details for Sending Payments to Nissan North America, Inc.";

  constructor() { }

  getIsConexioBankTransferAccountID(id: string): boolean {
    return this.conexioBankTransferAccountID.includes(id) ? true : false;
  }
}